<template>
  <div
    class="dayplanner-flowchart"
    @dblclick.self="onDblClickDayplan"
    @mousedown.self="onDayplanMouseDown">
    <!--<pre class="mini-pre m-2">drag_item_type: {{drag_item_type}}</pre>-->
    <!--<component
        v-for="(item, idx) in draggablesList.slice(0,1)"
        v-bind:is="item.component"
        :key="'x-item-'+item.groupId+'-'+item.id+'-'+idx"
        :class="{
          'action-draggable': true,
          'action-draggable--filtered': item.no_drag
        }"
        :value="draggablesList[ idx ]"
        :idx="idx"
        @input="onUpdateFlowBlock( item.sessionId, $event )"
        @update="onUpdateFlowBlock( item.sessionId, $event, true)"
        @change-time="onUserChangeTime( item.sessionId, $event.timeFrom, $event.timeTo, item )"
        @change-duration="onUserChangeDuration( item.sessionId, $event, item )"
        @lock-time="onUserLockTime( item.original_idx, $event.selection, $event.value, item )"
        @remove="onRemoveItem( item )"
        @duplicate="onAddItem( $event )"
        @drag-time="onUserDragTime(item, $event)"
        @drag-time-active="onDragTimeActive($event)"
        @drag-task-start="onDragTaskStart($event)"
        @drag-task-end="onDragTaskEnd($event)"
        :show-connection="true"
        :draggables-list-virtual-offsets="draggables_list_virtual_offsets"
        :drag-time-active="dragTimeActive || dragActive"
        :date-string="view_date_as_yymmdd /* TODO: REMOVE? */"
      />-->
    <header
      slot="header"
      class="flow-block p-2 clickable"
      style="min-height: unset; background-color: #d5e8fb;"
      v-if="view_is_multi_day"
      @click="onSelectDay">

      <div class="el-form-item--fat text-center">
        <el-radio :value="day_is_selected" :label="true" class="m-0">
          {{viewDate|longDateWithDay}}
        </el-radio>
      </div>
      <!--dayplanner_unfinished_tasks: <pre>{{ dayplanner_unfinished_tasks }}</pre>-->
    </header>
    <div  v-if="dayplanner_unfinished_tasks_old.length" style="margin-bottom: 1em;">
      <el-alert type="warning" :closable="false">
        <p class="p-0 text-justify">
          There are currently {{ dayplanner_unfinished_tasks_old.length }} unfinished tasks in past dayplans.
          You might want to mark them as done manually or click the very useful button to release them automatically from old dayplans.
        </p>
        <el-button
          class="btn-block"
          @click="onRemoveUnfinishedTasksFromSessions"
          style="font-weight: bold; color: #666666; padding: 12px;">
          Release {{ dayplanner_unfinished_tasks_old.length }} unfinished tasks from old dayplans
        </el-button>
      </el-alert>
    </div>

    <draggable
      class="dayplan-inner-container"
      v-model="draggablesList"
      :group="{
        name: 'sessions',
        put: ['tasks', 'sessions']
      }"
      :move="onDragMove"
      :refreshPositions="false"
      :animation="100"
      :swapThreshold="0.5"
      :forcePlaceholderSize="true"
      :scroll="true"
      :scrollSensitivity="300"
      :forceFallback="false"
      @update="onDragUpdate"
      @change="onDragChange"
      @start="onDragStart"
      @end="onDragAdd($event,'@end')"
      @add="onDragAdd($event,'@add')"
      @sort="onDragAdd($event,'@sort')"
      filter=".action-draggable--filtered"
      draggable=".action-draggable"
      chosenClass="sortable-chosen"
      dragClass="sortable-drag"
      :disabled="false"
      :dateString="view_selected_date_as_yymmdd">
      <!--
      dayplan_virtual_offsets: <pre>{{ dayplan_virtual_offsets}}</pre> <br />
      drag_time_offset: {{ drag_time_offset }}<br />
      drag_item: {{drag_item }}<br />
      drag_time_active: {{ drag_time_active }} <br />
      drag_time_selection: {{ drag_time_selection }}-->
      <!--
      <FlowDayPreview
        v-if="dateTimestamp >= moment.currentDate().unix() - 86400 && dayplanner_sessions.itemsAsArray().length > 0"
        :dateTimestamp="dateTimestamp"
        :dayplanner_sessions="dayplanner_sessions"
      />
      -->

      <!-- move to component -->

      <component
        v-for="(item, idx) in draggablesList"
        v-bind:is="item.component"
        :key="'x-item-'+item.groupId+'-'+item.id+'-'+idx"
        :class="{
          'action-draggable': item.type !== 'START_DAY' && item.type !== 'END_DAY',
          'action-draggable--filtered': item.no_drag
        }"
        :value="draggablesList[ idx ]"
        :idx="idx"
        @input="onUpdateFlowBlock( item.sessionId, $event )"
        @update="onUpdateFlowBlock( item.sessionId, $event, true)"
        @change-time="onUserChangeTime( item.sessionId, $event.timeFrom, $event.timeTo, item )"
        @change-duration="onUserChangeDuration( item.sessionId, $event, item )"
        @lock-time="onUserLockTime( item.original_idx, $event.selection, $event.value, item )"
        @remove="onRemoveItem( item )"
        @drag-time="onUserDragTime(item, $event, idx)"
        @drag-time-active="onDragTimeActive($event)"
        @drag-task-start="onDragTaskStart($event)"
        @drag-task-end="onDragTaskEnd($event)"
        :show-connection="idx !== draggablesList.length - 1"
        :draggables-list-virtual-offsets="dayplan_virtual_offsets"
        :drag-time-active="drag_time_active || drag_active"
        :date-string="view_date_as_yymmdd /* TODO: REMOVE? */"
      />

      <div
        v-if="intro.dayplanner_drag && day_is_selected"
        class="flow-block flow-block-commitment"
        style="left: -70px; width: 512px; max-width: none;">
        <div class="p-2">
          <strong>Info:</strong> Drop a task list into your dayplan to get started
          <font-awesome-icon
            size="2x"
            :icon="['fas', 'times']"
            class="inline-icon"
            style="
              cursor: pointer;
              float: right;
              width: 22px;
              height: 22px;
              display: block;
              padding: 3px;"
            @click="onHideIntro" />
        </div>
        <div class="p-2">
          <img src="/assets/onboarding/dayplanner_drag.gif" style="max-width: 100%;" />
        </div>
      </div>

    </draggable>
    <!--<footer slot="footer" class="flow-block p-2" >
      <pre class="mini-pre m-2">drag_target_date: {{drag_target_date}}</pre>
      <pre class="mini-pre m-2">drag_target_space: {{ drag_target_space}}</pre>
      <pre class="mini-pre m-2">drag_target_index: {{drag_target_index}}</pre>
      <pre class="mini-pre m-2">drag_item_placement: {{drag_item_placement}}</pre>
      <pre class="mini-pre m-2">drag_time_active: {{ drag_time_active }}</pre>
      <pre class="mini-pre m-2">dayplan_virtual_offsets: {{dayplan_virtual_offsets}}</pre>
      <pre class="mini-pre m-2">drag_time_selection: {{ drag_time_selection }}</pre>
      <pre class="mini-pre m-2">drag_item: {{drag_item}}</pre>
      <pre class="mini-pre m-2">drag_target_draggables_list: {{ drag_target_draggables_list }}</pre>
    </footer>-->
    <footer slot="footer" class="flow-block p-2" v-if="SHOW_DEBUG">
      <h6>DEBUG</h6>
      <pre class="mini-pre m-2">dayplan_virtual_offsets: {{dayplan_virtual_offsets}}</pre>
      <pre class="mini-pre m-2">drag_target_index: {{drag_target_index}}</pre>
      <pre class="mini-pre m-2">drag_target_date: {{drag_target_date}}</pre>
      <pre class="mini-pre m-2">drag_item_placement: {{drag_item_placement}}</pre>
      <pre class="mini-pre m-2">drag_target_index: {{drag_target_index}}</pre>
      <pre class="mini-pre m-2">drag_target_date: {{drag_target_date}}</pre>

      <!--
      <pre class="mini-pre m-2">drag_item_placement: {{drag_item_placement}}</pre>
      <pre class="mini-pre m-2">drag_item: {{drag_item}}</pre>
      <pre class="mini-pre m-2">drag_target_space: {{drag_target_space}}</pre>
      <pre class="mini-pre m-2">drag_item_type: {{drag_item_type}}</pre>
      <pre class="mini-pre m-2">drag_target_status_ok: {{drag_target_status_ok}}</pre>
      <pre class="mini-pre m-2">drag_item_placement: {{drag_item_placement}}</pre>
      <pre class="mini-pre m-2">drag_item: {{drag_item}}</pre>
      <pre class="mini-pre m-2">drag_time_active: {{ drag_time_active }}</pre>
      <pre class="mini-pre m-2">drag_time_selection: {{ drag_time_selection }}</pre>
      <pre class="mini-pre m-2">drag_time_offset: {{ drag_time_offset }}</pre>
      <pre class="mini-pre m-2">viewDate: {{ viewDate }}</pre>
      <pre class="mini-pre m-2">view_is_multi_day: {{ view_is_multi_day}}</pre>
      <pre class="mini-pre m-2">drag_target_date: {{ drag_target_date}}</pre>
      <pre class="mini-pre m-2">drag_target_index: {{ drag_target_index}}</pre>
      <pre class="mini-pre m-2">drag_target_space: {{ drag_target_space}}</pre>
      <pre class="mini-pre m-2">drag_target_status_ok: {{ drag_target_status_ok}}</pre>
      -->

      <!--
      <pre class="mini-pre m-2">draggablesList: {{ draggablesList}}</pre>
      <pre class="mini-pre m-2">dayplan_virtual_offsets: {{ dayplan_virtual_offsets }}</pre>
      <pre class="mini-pre m-2" style="overflow: scroll; width: 98%;">
        {{ draggablesList.map( (item, idx) => {
        return "[" + idx + ':' + item.original_idx + "] " + item.type + ': '
          + moment.unix(item.from).format('LT') + ' - '
          + moment.unix(item.to).format('LT')
          + ' (' + (item.from) + ' - ' + (item.to) + ')'
        }).join("\n") }}
      </pre>
      <pre class="mini-pre m-2">dayplan_virtual_offsets: {{dayplan_virtual_offsets}}</pre>
      <pre class="mini-pre m-2">drag_item_placement: {{drag_item_placement}}</pre>
      <pre class="mini-pre m-2">draggablesList: {{draggablesList}}</pre>
      <pre class="mini-pre m-2">dayplan_from_db: {{dayplan_from_db}}</pre>
      <pre class="mini-pre m-2">draggables_list_virtual_offsets: {{ draggables_list_virtual_offsets }}</pre>
      <pre class="mini-pre m-2">drag_target_space: {{ drag_target_space }}</pre>
      <pre class="mini-pre m-2">drag_target_draggables_list: {{ drag_target_draggables_list }}</pre>
      <pre class="mini-pre m-2">viewDate: {{ viewDate }}</pre>
      -->

      <!-- <pre class="mini-pre">draggables_list_virtual_offsets: {{draggables_list_virtual_offsets}}</pre> -->
      <!-- <pre class="mini-pre">dayplan_remaining_timeslots: {{dayplan_remaining_timeslots}}</pre> -->
      <!-- <pre class="mini-pre m-2">dayplanner_sessions: {{ dayplanner_sessions }}</pre> -->
      <!-- <pre class="mini-pre m-2">commitmentData: {{ commitmentData }}</pre>-->
      <!-- <pre class="mini-pre m-2">optimizer_result_data: {{ optimizer_result_data }} </pre>-->
      <!-- <pre class="pre-mini" v-if="optimizer_result_data">{{ optimizer_result_data['dayplan_suggestions'] }}</pre>-->
      <!-- <pre class="mini-pre m-2">snapshot_stack: {{snapshot_stack}}</pre> -->
      <!-- <pre class="mini-pre m-2">snapshot_stack_redo: {{snapshot_stack_redo}}</pre> -->
      <!-- <pre class="mini-pre m-2">google_eventlist: {{google_eventlist}}</pre> -->

    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import Draggable from "vuedraggable";
import moment from "@/moment-gp";
import util from "@/util";
import clonedeep from "lodash.clonedeep";
//import { make_block } from "./API/util";
import { mapReady } from "@/api/misc";

// TODO: webpack context
import FlowDummy from "@/components/TodayPage/Elements/Flow/FlowDummy";
import FlowTasklist from "@/components/TodayPage/Elements/Flow/FlowTasklist";
import FlowSequence from "@/components/TodayPage/Elements/Flow/FlowSequence";
import FlowPlaceholder from "@/components/TodayPage/Elements/Flow/FlowPlaceholder";
import FlowFixedTimeEvent from "@/components/TodayPage/Elements/Flow/FlowFixedTimeEvent";
import FlowQuickSession from "@/components/TodayPage/Elements/Flow/FlowQuickSession";
import FlowTimeBlock from "@/components/TodayPage/Elements/Flow/FlowTimeBlock";
import FlowTimeslotBreaker from "@/components/TodayPage/Elements/Flow/FlowTimeslotBreaker";
import FlowDayMarker from "@/components/TodayPage/Elements/Flow/FlowDayMarker";
import FlowCurrentTime from "@/components/TodayPage/Elements/Flow/FlowCurrentTime";
import FlowExternal from "@/components/TodayPage/Elements/Flow/FlowExternal";
import FlowDayPreview from "@/components/TodayPage/Elements/Flow/FlowDayPreview";

import DayplannerSidebar from "@/components/TodayPage/DayplannerSidebar";
import GoogleCalendarMixin from "@/components/TodayPage/Elements/GoogleCalendarMixin";
import DayplannerNavigationBar from "@/components/TodayPage/DayplannerNavigationBar";
import SessionManagementMixin from "@/components/Mixins/SessionManagement"
import SuggestionItemMixin from '@/components/TodayPage/Elements/Suggestions/SuggestionItemMixin.js'
import "./Style/dayplanner.scss";

// TODO: Make certain items not movable --> see kanban
// TODO: Move data model to vuex?

const log1 = (...args) => console.log("[DPE]", ...args);
//const log2 = (...args) => console.log("[DPE2]", ...args);
const log3 = (...args) => console.log("[DPE3]", ...args);

export default {
  mixins: [ GoogleCalendarMixin, SessionManagementMixin, SuggestionItemMixin ],
  props: {
    viewDate: {
      required: true,
      type: Object
    },
    memberId: {
      type: String
    }
  },
  data: () => ({
    //dragActive: false,
    //dragItem: null,
    dragSourceIdx: null,
    dragTargetIdx: null,
    dragTargetFrom: null, // UNUSED
    dragTargetTo: null, // UNUSED
    dateTimestamp: null, // UNUSED
    //dragTimeActive: false,
    //dragTimeSelection: null, // ok
    //drag_item: null, // ok

    draggablesListVirtual: null,
    // dragTaskItemFrom: null, // task that is dragged within or between tasklists
  }),
  mounted() {
    console.log("[DayplanEditor] MOUNTED");
  },
  watch: {
    /*'draggablesList.length'(len) {
      if ( len >= 4 && this.intro.dayplanner_drag ) {
        this.onHideIntro();
      }
    }*/
  },
  computed: {
    ...mapReady("goals", "commitments", "optimizer_input"),
    ...mapGetters("app", [
      "intro",
    ]),
    ...mapGetters("dayplanner", [
      'drag_item',
      'drag_item_type',
      'dayplan_max_sortidx',
      'dayplan_remaining_timeslots',
      'view_selected_date_as_yymmdd',
      'show_nothing_planned',
      'show_reduced_dayplan',
      'view_is_multi_day',
      'dayplanner_sessions',
      'dayplan_from_db_at_date',
      'drag_target_date',
      'drag_target_index',
      'drag_target_dayplan',
      'drag_target_space',
      'draggables_list_at_date',
      'drag_target_draggables_list',
      'drag_target_status_ok',
      'drag_item_placement',
      'dayplan_virtual_offsets',
      'drag_active',
      'drag_time_active',
      'drag_time_selection',
      'drag_time_offset',
      'dayplanner_unfinished_tasks',
      'dayplanner_unfinished_tasks_old'
    ]),
    ...mapGetters('optimizer', [
      'optimizer_manual_dayplan',
      'optimizer_finish_dates_commitments',
      'optimizer_result_data',
    ]),

    day_is_selected() {
      return this.viewDate.format('YYMMDD') === this.view_selected_date_as_yymmdd;
    },

    dayplan_from_db() {
      //console.log('markerA', this.viewDate, this.dayplan_from_db_at_date( this.viewDate ))
      return this.dayplan_from_db_at_date( this.view_date_as_yymmdd );
    },

    moment() {
      return moment;
    },

    view_date_as_yymmdd() {
      return this.viewDate.format('YYMMDD');
    },

    // TODO: Move to vuex
    optimizer_sessions_today() {

      // log2("sessionItems", clonedeep(this.view_current_data_as_timestamp));

      if (this.optimizer_result_data["sessionItems"]) {
        // TODO: take wakeup and bed time into account
        return this.optimizer_result_data["sessionItems"]
          .filter(session => session.dateString === this.view_selected_date_as_yymmdd);
      } else {
        return [];
      }
    },

    draggablesList: {
      get() {
        let draggablesList = this.draggables_list_at_date(this.viewDate.format('YYMMDD'))
        draggablesList.forEach(item => {
          if (item.type === "TASKLIST") {
            item.tasks = this.taskIds_in_session(item.sessionId);
          }
        })
        return draggablesList
      },
      set(dayplan_with_placeholders) {
      },
    },
  },
  methods: {
    ...mapActions("app", [
      "hideIntro",
    ]),
    ...mapActions("optimizer", [
      "optimizer_set_manual_dayplan",
      "optimizer_trigger"
    ]),
    ...mapActions("dayplanner", [
      //'createSnapshot',
      'setDragTargetDate',
      'setDragTargetIndex',
      'setDragTimeActive',
      'setDragTimeSelection',
      'setDragTimeOffset',
      'setDragItem',
      'setDragActive'
    ]),
    ...mapMutations("dayplanner", [
      'TOGGLE_SHOW_REDUCED_DAYPLAN',
      'SELECT_DATE',
      'HIDE_BACKLOG_ALL',
    ]),

    onSelectDay() {
      // log2("onSelectDay", this.viewDate.format())
      this.SELECT_DATE( this.viewDate.toStore() )
    },

    onRemoveItem(item) {

      this.removeSession(item)
      //this.dayplan_from_db.splice(idx, 1);
    },

    onUserDragTime(item, { selection, offset }, idx) {
      this.setDragTargetDate(this.view_date_as_yymmdd)
      this.setDragTargetIndex(idx)

      this.setDragItem(item)
      this.setDragTimeSelection(selection)
      this.setDragTimeOffset(offset)
      //this.setDragTimeActive(true)
      // LEGACY
      /*this.drag_item = item;
      this.dragTimeSelection = selection;
      this.drag_time_offset = offset;*/
    },
    onMouseoverSetDragDate() {
      //console.log('onMouseoverSetDragDate', this.view_date_as_yymmdd)
      this.setDragTargetDate(this.view_date_as_yymmdd)
    },
    onDragTimeActive({ value }) {
      //console.log('onDragTimeActive')
      this.setDragTimeActive(value)

      // LEGACY
      /*this.dragTimeActive = value;
      if (this.dragTimeActive) {
        this.drag_time_offset = 0;
      } else {
        this.drag_item = null;
        this.dragTimeSelection = null;
        this.drag_time_offset = null;
      }*/
    },

    onUserChangeDuration(sessionId, duration, item) {
      //console.log("onUserChangeDuration", sessionId, duration, item)

      /*this.$models.userDayplannerSessions.update(sessionId, {
        from: item.from,
        to:   item.from + duration,
      });*/
    },

    onUserChangeTime(sessionId, timeFrom, timeTo, item) {
      log1("onUserChangeTime", sessionId, timeFrom, timeTo, item);
      //this.createSnapshot(this.dayplan_from_db);

      /*console.log('onUserChangeTime update 1',
        Object.keys(this.dayplan_virtual_offsets),
        Object.keys(this.dayplan_virtual_offsets).map(idx => this.dayplan_virtual_offsets[idx])
      )*/
      Object.keys(this.dayplan_virtual_offsets).map(idx => this.dayplan_virtual_offsets[idx]).filter(session => session.sessionId).forEach(session => {
        //console.log('onUserChangeTime update 2', session)
        if (session.sessionId) { //&& (session.from !== 0 || session.to !== 0)) {
          if (session.sessionId && session.newFrom && session.newTo) {
            this.$models.userDayplannerSessions.update(session.sessionId, {
              from: session.newFrom,
              to:   session.newTo,
            })
          }
        }
      })
      if (!sessionId) {
          this.$models.userDayplannerSessions.add({
            dateString:   this.view_date_as_yymmdd,
            from:         timeFrom,
            to:           timeTo,
            sortidx:      item.sortidx,
            type:         item.type,
            createdAt:    moment.currentTime().unix()
          });
      } else {
      }
    },

    onUserLockTime(idx, selection, value, item) {
      //this.createSnapshot(this.dayplan);

      log1("onUserLockTime", idx, selection, value);
      switch (selection) {
        case "from":
          this.$models.userDayplannerSessions.update(item.sessionId, {
            fixedFrom: value,
          });
          break;
        case "to":
          this.$models.userDayplannerSessions.update(item.sessionId, {
            fixedTo: value,
          });
          break;
        case "duration":
          this.$models.userDayplannerSessions.update(item.sessionId, {
            fixedDuration: value,
          });
          break;
      }
    },

    onUpdateFlowBlock(sessionId, item, isPatch = false) {
      // this.createSnapshot(this.dayplan);

      console.log("onUpdateFlowBlock", sessionId, item, isPatch)

      /*if ( isPatch ) {
        Vue.set(this.dayplan[idx], item.prop, item.value)
      } else {
        Vue.set(this.dayplan, idx, item);
      }*/

      // TODO !!!!
      if ( isPatch ) {
        this.$models.userDayplannerSessions.update(sessionId, item);
      }
    },

    onDragStart($event) {
      // When moving a session, hide backlog
      // this.HIDE_BACKLOG_ALL(); --> does not work

      log1("onDragStart", $event);
      let oldIndex = clonedeep($event.oldIndex)
      this.setDragTargetDate(this.view_date_as_yymmdd)
      this.setDragTargetIndex($event.oldIndex)

      this.$nextTick(() => {
        this.onDragSessionStart(clonedeep(this.draggablesList)[oldIndex])
      })
      //this.dragActive = true;
    },

    onDragEnd($event) {
      //console.log("onDragEnd");

      this.setDragTimeActive(false)
      this.setDragItem(null)
      // LEGACY
      //this.drag_active = false;
      //this.dragItem = null;
      this.dragSourceIdx = null;
      this.dragTargetIdx = null;
    },

    onDragAdd($event, test) {
      if (!this.drag_item) {
        return
      }
      let newIndex = clonedeep($event.newIndex)
      /*if (this.view_is_multi_day) {
        newIndex -= 1
      }*/

      log3('onDragAdd', newIndex,'test:', test)
      let destination = {
        newIndex: newIndex,
        dateString: this.view_date_as_yymmdd,
        draggablesList: this.draggablesList,
        memberId: this.memberId
      }

      log3('onDragAdd destination', destination)
      if (this.drag_item) {
        this.onDragSessionEnd(destination, 'onDragAdd')
      }

      this.setDragActive(false)
      this.setDragItem(null)
      this.setDragTargetDate(null)
      this.setDragTargetIndex(null)
      this.dragSourceIdx = null;
      this.dragTargetIdx = null;

    },

    onDragUpdate( originalEvent) {
      log3('onDragUpdate', this.view_date_as_yymmdd, originalEvent)
    },
    onDragChange($event) {
      console.log('onDragChange', this.view_date_as_yymmdd, $event)
      /*
      let newIndex = $event.moved.newIndex

      console.log('onDragChange', newIndex)
      let destination = {
        newIndex: newIndex,
        dateString: this.view_date_as_yymmdd,
        draggablesList: this.draggablesList,
        memberId: this.memberId
      }

      console.log('onDragChange destination', destination)

      this.onDragSessionEnd(destination, 'onDragChange')

      this.setDragActive(false)
      this.dragSourceIdx = null;
      this.dragTargetIdx = null;*/
    },

    onDragMove($event) {
      console.log('onDragMove', this.view_date_as_yymmdd, $event)
      if (this.drag_item) {
        /*log3('onDragMoveindices',
          'drag_item.original_idx:',this.drag_item.original_idx,
          'draggedContext futureIndex', $event.draggedContext.futureIndex || null,
          'index', $event.draggedContext.index || null,
          'original_idx', $event.draggedContext.element.original_idx || null,
          'relatedContext index', $event.relatedContext.index || null,
          'index', $event.draggedContext.index || null,
          'original_idx', $event.draggedContext.element.original_idx || null,
          $event,
          '$event.relatedContext.element.original_idx', $event.relatedContext.element.original_idx,
          '$event.draggedContext.element.original_idx', $event.draggedContext.element.original_idx)
        log3('onDragMove', $event, $event.related, $event.draggedContext,$event.relatedContext, $event.draggedContext.index)
        log3('onDragMove data',$event.draggedContext.futureIndex,$event.draggedContext.index, clonedeep($event.draggedContext.element.original_idx))*/
        let newIndex = null
        let dateString = null
        if ($event.related.attributes.getNamedItem('date-string') && $event.draggedContext.element) {
          dateString = $event.related.attributes.getNamedItem('date-string').nodeValue
          /*if ($event.draggedContext.element.original_idx - this.drag_item.original_idx > 0) {
            log3('onDragMoveindices marker1',$event.draggedContext.element.original_idx - this.drag_item.original_idx)
            newIndex = $event.draggedContext.futureIndex - ($event.draggedContext.element.original_idx - this.drag_item.original_idx)
          } else {
            newIndex = $event.draggedContext.index
          }*/
          newIndex = $event.draggedContext.futureIndex
          /*if (this.view_is_multi_day) {
            newIndex -= 1
          }*/

          if (newIndex && !isNaN(newIndex)) {

            if (dateString) {
              this.setDragTargetDate(dateString)
              log3('onDragMoveindices set newIndex',newIndex)
              /*log3('onDragMoveindices',
              'drag_item.original_idx:',this.drag_item.original_idx,
              'draggedContext futureIndex', $event.draggedContext.futureIndex || null,
              'index', $event.draggedContext.index || null,
              'original_idx', $event.draggedContext.element.original_idx || null,
              'relatedContext index', $event.relatedContext.index || null,
              'index', $event.draggedContext.index || null,
              'original_idx', $event.draggedContext.element.original_idx || null,
              $event,
              '$event.relatedContext.element.original_idx', $event.relatedContext.element.original_idx,
              '$event.draggedContext.element.original_idx', $event.draggedContext.element.original_idx)*/
              this.setDragTargetIndex(newIndex)
              this.setDragActive(true)
              //this.dragActive = true;
            }
          }
          //let cancelDrag = !Array.from($event.related.classList).includes("action-draggable--filtered");
          if (!newIndex || this.drag_target_status_ok === false) {
            log3('onDragMove returning false for placement', !newIndex, this.drag_target_status_ok === false)
            return false
          } else {
            log3('onDragMove newIndex:', newIndex)
            return true
          }
        }
      }
      return false
    },

    getDayplanAsOptimizerInput() {
      return this.draggablesList
        .filter(item => item.type === "TASKLIST" || item.type === "SEQUENCE")
        .map(item => {
          let itemObj = {
            type: item.type,
            from: item.from,
            to: item.to,
            commitmentId: item.config.commitmentId || null,
            sessionId: item.sessionId,
          };
          if (item.type === "TASKLIST") {
          }
          if (item.type === "SEQUENCE") {
            Object.assign(itemObj, { sequenceItems: item.sequenceItems });
          }
          return itemObj;
        })
        .sort(util.sorter.by_from);
    },

    // ----------------------------------------------------------------------------------------------

    // TODO: Move to Session and get caching for free!
    taskIds_in_session(sessionId) {
      //log2("taskIds_in_session sessionId", sessionId, this.dayplanner_sessions);
      let tasks = [];
      if (this.dayplanner_sessions.$readyAll) {
        let sessions = this.dayplanner_sessions.itemsAsArray().filter(session => session.$id === sessionId);
        //log2("taskIds_in_session sessions", sessions);
        if (sessions.length === 1) {
          let session = sessions[0];
          //log2("taskIds_in_session session", session);
          tasks = clonedeep(session.tasks) || [];
          /*let taskDurationTotal = 0;
          for (let i = 0; i < tasks.length; i++) {
            taskDurationTotal += tasks[i].duration;
          }
          let buffer = session.to.unix() - session.from.unix() - taskDurationTotal;
          //log2("taskIds_in_session buffer", buffer, taskDurationTotal);
          let tmpTaskFrom = session.from.unix();
          //log2("CHECK1 tasks:", clonedeep(tasks));
          for (let i = 0; i < tasks.length && tasks[i] && tasks[i].from; i++) {
            tasks[i].from = tmpTaskFrom;
            tmpTaskFrom += tasks[i].duration + Math.floor(buffer / tasks.length);
          }*/
        }
        //log2("taskIds_in_session tasks", tasks);
      }
      return tasks;
    },

    // TODO: Move to Session and get caching for free!
    taskIds_for_session(sessionId) {
      // these are suggestions from the optimizer
      let sessions = clonedeep(this.optimizer_sessions_today.filter(session => session.sessionId === sessionId));
      if (sessions.length !== 1) {
        return []
      }

      let tasks = [];
      let session = sessions[0];
      let nextTaskFrom = session.from;
      let from = session.from;
      let until = session.until;

      //log2('taskIds_for_session',commitmentId, clonedeep(sessions))
      session.tasks.forEach(task => {
        let taskFrom = nextTaskFrom;
        let taskUntil = nextTaskFrom + task.duration;
        let durationInSession = taskUntil
          - taskFrom
          - Math.max(session.from - taskFrom, 0)
          - Math.max(taskUntil - session.until, 0);
        if (durationInSession > 0) {
          if (session.type === "TASKLIST") {
            tasks.push({
              taskId: task.taskId,
              durationInSession: durationInSession,
              from: Math.max(taskFrom, from),
              until: Math.min(taskUntil, until),
              devFrom: moment.unix(Math.max(taskFrom, from)).format(),
              devUntil: moment.unix(Math.min(taskUntil, until)).format(),
            });
          } else if (session.type === "SEQUENCE") {
            tasks.push({
              sequenceItemId: task.sequenceItemId,
              title: task.title,
              durationInSession: durationInSession,
              from: Math.max(taskFrom, from),
              until: Math.min(taskUntil, until),
              devFrom: moment.unix(Math.max(taskFrom, from)).format(),
              devUntil: moment.unix(Math.min(taskUntil, until)).format(),
            });
          }
        }
        nextTaskFrom += taskUntil - taskFrom;
      });
      return tasks;
    },

    onHideIntro() {
      this.hideIntro('dayplanner_drag')
    },

    onDblClickDayplan() {
      // this.showReducedDayplan = (this.showReducedDayplan + 1) % 2
      this.TOGGLE_SHOW_REDUCED_DAYPLAN();
    },

    onDayplanMouseDown(event) {
      if ( event.detail > 1 ) {
        event.preventDefault();
      }
    },
  },
  components: {
    FlowDummy,
    FlowTasklist,
    FlowSequence,
    FlowPlaceholder,
    FlowTimeBlock,
    FlowQuickSession,
    FlowFixedTimeEvent,
    FlowTimeslotBreaker,
    FlowDayMarker,
    FlowCurrentTime,
    FlowExternal,
    FlowDayPreview,
    DayplannerSidebar,
    DayplannerNavigationBar,
    Draggable,
  },
};
</script>

<style>

.dayplanner-flowchart {
  /*width: 375px;*/
  width: 345px;
  min-width: 345px;
  margin: 0 auto;
  margin-top: 1em;
}

.dayplan--multi-column-layout .dayplanner-flowchart:not(:last-child) {
  /* spacing between days in multi day view */
  margin-right: 1em;
}

.dayplan-inner-container {
}

.dayplan-inner-container .action-draggable.sortable-ghost {
  min-height: 107px;
  border: 1px dashed #BBB;
  padding: 0;
  margin-bottom: 25px;
  position: relative;
}

.dayplanner-flowchart .el-alert__content {
  /* Fixes issue with text positioning inside alert */
  padding: 0;
}

/******************** DRAG AND DROP STYLING *******************/

/* .dayplan-inner-container */ .sortable-ghost .hide-during-dayplanner-drop {
  /*visibility: hidden;*/
  display: none;
}
.dayplan-inner-container .sortable-chosen .dayplanner-suggestion-card {
  margin: 0.5rem !important;
  border: 1px solid #AAA;
  border-radius: 3px;
}
.dayplan-inner-container .sortable-ghost .dayplanner-suggestion-caret,
.dayplan-inner-container .sortable-chosen .dayplanner-suggestion-caret {
  display: none;
}

/* .dayplanner-page-editor .dayplanner-page-packs--hide > button {
  transform: rotate(90deg) translate(23px, 9px);
} */
</style>
